/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Document } from 'bundles/cml/shared/components/asset/pdfViewer/Document';
import { usePdfViewerContext } from 'bundles/cml/shared/components/asset/pdfViewer/PdfViewerContext';
import { Toolbar } from 'bundles/cml/shared/components/asset/pdfViewer/Toolbar';

const styles = {
  pdfViewer: css`
    border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
  `,
};

type Props = {
  showSidePageCount: boolean;
};

export const PdfViewerUI = ({ showSidePageCount }: Props) => {
  const { pdfViewerRef } = usePdfViewerContext();

  return (
    <div ref={pdfViewerRef} css={styles.pdfViewer}>
      <Toolbar />
      <Document showSidePageCount={showSidePageCount} />
    </div>
  );
};
